import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["classId", "search", "userIds"];
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
export var CLASS_API = 'CLASS_API';
export var ClassApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ClassApi, _AxiosApi);

  var _super = _createSuper(ClassApi);

  function ClassApi(axiosInstance) {
    var _this;

    _classCallCheck(this, ClassApi);

    _this = _super.call(this, 'classes', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(ClassApi, [{
    key: "list",
    value: function () {
      var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get(this.url, {
                  params: input
                });

              case 3:
                response = _context.sent;
                body = response.data;
                return _context.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function list(_x) {
        return _list.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.post(this.url, input);

              case 3:
                response = _context2.sent;
                body = response.data;
                return _context2.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.axios.get("".concat(this.url, "/").concat(id));

              case 3:
                response = _context3.sent;
                body = response.data;
                return _context3.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "listMembers",
    value: function () {
      var _listMembers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input, role) {
        var classId, search, userIds, params, url, response, body;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                classId = input.classId, search = input.search, userIds = input.userIds, params = _objectWithoutProperties(input, _excluded);
                url = "".concat(this.url, "/").concat(encodeURIComponent(classId), "/").concat(role);

                if (!(search !== null && search !== void 0 && search.trim())) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 6;
                return this.axios.post("".concat(url, "/search"), {
                  search: search.trim(),
                  userIds: userIds !== null && userIds !== void 0 ? userIds : []
                }, {
                  params: params
                });

              case 6:
                _context4.t0 = _context4.sent;
                _context4.next = 12;
                break;

              case 9:
                _context4.next = 11;
                return this.axios.get(url, {
                  params: params
                });

              case 11:
                _context4.t0 = _context4.sent;

              case 12:
                response = _context4.t0;
                body = response.data;
                return _context4.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 17:
                _context4.prev = 17;
                _context4.t1 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t1));

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 17]]);
      }));

      function listMembers(_x4, _x5) {
        return _listMembers.apply(this, arguments);
      }

      return listMembers;
    }()
  }, {
    key: "listTeachers",
    value: function listTeachers(input) {
      return this.listMembers(input, 'teachers');
    }
  }, {
    key: "listStudents",
    value: function listStudents(input) {
      return this.listMembers(input, 'students');
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, input) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.axios.put("".concat(this.url, "/").concat(id), input);

              case 3:
                response = _context5.sent;
                body = response.data;
                return _context5.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));

      function update(_x6, _x7) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "archive",
    value: function () {
      var _archive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.axios.patch("".concat(this.url, "/").concat(id, "/archive"));

              case 3:
                response = _context6.sent;
                body = response.data;
                return _context6.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function archive(_x8) {
        return _archive.apply(this, arguments);
      }

      return archive;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.axios.patch("".concat(this.url, "/").concat(id, "/activate"));

              case 3:
                response = _context7.sent;
                body = response.data;
                return _context7.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 8]]);
      }));

      function activate(_x9) {
        return _activate.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: "removeTeacher",
    value: function () {
      var _removeTeacher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(classId, teacherId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.axios["delete"]("".concat(this.url, "/").concat(classId, "/teachers/").concat(teacherId));

              case 3:
                return _context8.abrupt("return", Result.ok(undefined));

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));

      function removeTeacher(_x10, _x11) {
        return _removeTeacher.apply(this, arguments);
      }

      return removeTeacher;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.axios["delete"]("".concat(this.url, "/").concat(id));

              case 3:
                return _context9.abrupt("return", Result.ok(undefined));

              case 6:
                _context9.prev = 6;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 6]]);
      }));

      function _delete(_x12) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "removeStudent",
    value: function () {
      var _removeStudent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(classId, studentId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.axios["delete"]("".concat(this.url, "/").concat(classId, "/students/").concat(studentId));

              case 3:
                return _context10.abrupt("return", Result.ok(undefined));

              case 6:
                _context10.prev = 6;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", ErrorResultHandler(_context10.t0));

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 6]]);
      }));

      function removeStudent(_x13, _x14) {
        return _removeStudent.apply(this, arguments);
      }

      return removeStudent;
    }()
  }, {
    key: "getInvitation",
    value: function () {
      var _getInvitation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(input) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.axios.get("".concat(this.url, "/").concat(input.classId, "/invitation"), {
                  params: {
                    classCode: input.classCode
                  }
                });

              case 3:
                response = _context11.sent;
                body = response.data;
                return _context11.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", ErrorResultHandler(_context11.t0));

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function getInvitation(_x15) {
        return _getInvitation.apply(this, arguments);
      }

      return getInvitation;
    }()
  }, {
    key: "getInvitationByCode",
    value: function () {
      var _getInvitationByCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(classCode) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return this.axios.get("".concat(this.url, "/invitation/by-code"), {
                  params: {
                    classCode: classCode
                  }
                });

              case 3:
                response = _context12.sent;
                body = response.data;
                return _context12.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", ErrorResultHandler(_context12.t0));

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 8]]);
      }));

      function getInvitationByCode(_x16) {
        return _getInvitationByCode.apply(this, arguments);
      }

      return getInvitationByCode;
    }()
  }, {
    key: "joinAsTeacher",
    value: function () {
      var _joinAsTeacher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(input) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return this.axios.post("".concat(this.url, "/").concat(input.classId, "/join"), {
                  classCode: input.classCode
                });

              case 3:
                response = _context13.sent;
                body = response.data;
                return _context13.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context13.prev = 8;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", ErrorResultHandler(_context13.t0));

              case 11:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 8]]);
      }));

      function joinAsTeacher(_x17) {
        return _joinAsTeacher.apply(this, arguments);
      }

      return joinAsTeacher;
    }()
  }, {
    key: "joinAsStudent",
    value: function () {
      var _joinAsStudent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(input) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return this.axios.post("".concat(this.url, "/").concat(input.classId, "/join"), {
                  classCode: input.classCode
                });

              case 3:
                response = _context14.sent;
                body = response.data;
                return _context14.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", ErrorResultHandler(_context14.t0));

              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 8]]);
      }));

      function joinAsStudent(_x18) {
        return _joinAsStudent.apply(this, arguments);
      }

      return joinAsStudent;
    }()
  }, {
    key: "leave",
    value: function () {
      var _leave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return this.axios.post("".concat(this.url, "/").concat(id, "/leave"));

              case 3:
                return _context15.abrupt("return", Result.ok(undefined));

              case 6:
                _context15.prev = 6;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", ErrorResultHandler(_context15.t0));

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 6]]);
      }));

      function leave(_x19) {
        return _leave.apply(this, arguments);
      }

      return leave;
    }()
  }]);

  return ClassApi;
}(AxiosApi);